import React, { Fragment } from 'react'
import logo from '../images/fielcode_logo.png'

const IndexPage = () => (
  <Fragment>
    <section id='hero' className='hero is-fullheight'>
      <div className='hero-body'>
        <div className='container'>
          <h1 className='title'>
            <img src={logo} alt='Fiel Code' />
          </h1>
          <br />
          <p className='subtitle'>Em breve...</p>
        </div>
      </div>
    </section>
  </Fragment>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js